import { authApi } from '../api/authApi'
import type { ApiError } from '@/types/api'

export const checkSetupToken = async (token: string) => {
  try {
    const response = await authApi.checkSetupToken(token)
    return response.data
  } catch (err) {
    const error = err as ApiError
    throw error
  }
}
